import React from 'react';
import { Filter } from 'lucide-react';

interface WorkoutFiltersProps {
  selected: string;
  onSelect: (filter: string) => void;
}

export function WorkoutFilters({ selected, onSelect }: WorkoutFiltersProps) {
  const filters = [
    { id: 'all', label: 'All' },
    { id: 'strength', label: 'Strength' },
    { id: 'cardio', label: 'Cardio' },
    { id: 'hiit', label: 'HIIT' },
    { id: 'recovery', label: 'Recovery' }
  ];

  return (
    <div className="flex items-center gap-2">
      <Filter className="w-4 h-4 text-muted-foreground" />
      {filters.map((filter) => (
        <button
          key={filter.id}
          onClick={() => onSelect(filter.id)}
          className={`px-3 py-1.5 rounded-lg text-sm transition-colors ${
            selected === filter.id
              ? 'bg-primary text-primary-foreground'
              : 'bg-muted text-muted-foreground hover:bg-muted/70'
          }`}
        >
          {filter.label}
        </button>
      ))}
    </div>
  );
}